import { startCase } from 'es-toolkit';
import React from 'react';
import DuplicateIcon from '@mui/icons-material/ContentCopy';
import MirrorIcon from '@mui/icons-material/Flip';
import MoveIcon from '@mui/icons-material/OpenWith';
import RotateIcon from '@mui/icons-material/WifiProtectedSetup';
import { Divider } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../../../components/hooks';
import { SceneMenuFragment } from '../../../components/misc/menus/common/SceneMenuFragment';
import { SceneMenuItem } from '../../../components/misc/menus/common/SceneMenuItem';
import { useAppMonitor } from '../../../monitor';
import { beginTransformation } from '../../../store/actions/layout/transformationActions';
import { typeToPluralUserVisibleString, typeToUserVisibleString } from '../../selection/types';
import { getCurrentTransformationTargets } from '../selectors';

export function TransformationMenuItems() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const targets = useAppSelector(getCurrentTransformationTargets);
  if (targets == null) return null;

  const userVisibleType = startCase(
    (targets.entities.length > 1 ? typeToPluralUserVisibleString : typeToUserVisibleString)(targets.type),
  );

  return (
    <SceneMenuFragment>
      <Divider />

      <SceneMenuItem
        text={`Duplicate ${userVisibleType}`}
        icon={<DuplicateIcon />}
        onClick={() => {
          dispatch(beginTransformation('movement', { duplicate: true }));
          monitor.recordInteraction(`${userVisibleType} => Duplicate ${userVisibleType} menu item clicked`);
        }}
      />

      <SceneMenuItem
        text={`Move ${userVisibleType}`}
        icon={<MoveIcon />}
        onClick={() => {
          dispatch(beginTransformation('movement'));
          monitor.recordInteraction(`${userVisibleType} => Move ${userVisibleType} menu item clicked`);
        }}
      />

      <SceneMenuItem
        text={`Rotate ${userVisibleType}`}
        icon={<RotateIcon />}
        onClick={() => {
          dispatch(beginTransformation('rotation'));
          monitor.recordInteraction(`${userVisibleType} => Rotate ${userVisibleType} menu item clicked`);
        }}
      />

      <SceneMenuItem
        text={`Mirror ${userVisibleType}`}
        icon={<MirrorIcon />}
        onClick={() => {
          dispatch(beginTransformation('mirror'));
          monitor.recordInteraction(`${userVisibleType} => Mirror ${userVisibleType} menu item clicked`);
        }}
      />

      <Divider />
    </SceneMenuFragment>
  );
}
